import { IconBed, IconInfoCircle } from '@tabler/icons-react';
import { RoomType, RoomTypesQuery } from '../../../gql/graphql';
import RoomCard from './RoomCard';
import { RoomDetail } from '../../../hooks/useCreateBooking';

interface Props {
  rooms: RoomTypesQuery;
  currency: string;
  tripSelected: boolean;
  setShowRoomAmenities: (room: RoomType) => void;
  currentSettedDivers: number;
  setCurrentSettedDivers: (divers: number) => void;
  setSelectedRoomIds: (roomIds: RoomDetail[]) => void;
  selectedRoomIds: RoomDetail[];
}

const BoatRoomComponent = (props: Props) => {
  return (
    <div className="mt-8 md:flex flex-col gap-6 items-start">
      <div className="flex flex-col items-start gap-2 flex-grow flex-shrink-0">
        <div className="flex items-center gap-2 text-neutral-800">
          <IconBed />
          <span className="text-xl font-semibold leading-normal">Rooms</span>
        </div>
        <span className="text-neutral-500 text-base font-normal leading-normal">
          Select from the available rooms below to secure your stay on the
          liveaboard trip.
        </span>
      </div>
      {!props.tripSelected && (
        <div className="flex p-4 mt-4 items-center content-center gap-3 self-strech flex-wrap bg-neutral-20 rounded-lg">
          <div className="flex items-center gap-3 flex-grow flex-shrink-0 flex-1">
            <span className="text-neutral-800">
              <IconInfoCircle size={16} />
            </span>
            <span className="text-neutral-800">
              Please pick your trip to proceed with booking the available rooms.
            </span>
          </div>
        </div>
      )}
      {props.rooms.roomTypes.map(room => (
        <div key={room.typeId}>
          <RoomCard
            room={room}
            currency={props.currency}
            tripSelected={props.tripSelected}
            setShowRoomAmenities={props.setShowRoomAmenities}
            currentSettedDivers={props.currentSettedDivers}
            setCurrentSettedDivers={props.setCurrentSettedDivers}
            setSelectedRoomIds={props.setSelectedRoomIds}
            selectedRoomIds={props.selectedRoomIds}
          />
        </div>
      ))}
    </div>
  );
};

export default BoatRoomComponent;
